export default {
  programUIState: (state) => state.programUIState
}